export default class Parameter {

  id = null;

  name = "";
  type = null;
  subType = "";

  useValue = false;
  valueType = null;

  constructor() {
  }
}
